import NearMissDetails from "./components/NearMissDetails";

export default NearMissDetails;